import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../config/api';

interface User {
  id: number;
  email: string;
  username: string;
  full_name?: string;
  umbrella_user_id?: string;
  timezone: string;
  customer_timezone: string;
  email_notifications: boolean;
  is_active: boolean;
  is_superuser: boolean;
  created_at: string;
  updated_at?: string;
  synthflow_api_token?: string;
}

interface UpdateUserRequest {
  email?: string;
  username?: string;
  full_name?: string;
  timezone?: string;
  customer_timezone?: string;
  email_notifications?: boolean;
  synthflow_api_token?: string;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/api/v1/users'),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getCurrentUser: builder.query<User, void>({
      query: () => '/me',
      providesTags: ['User'],
    }),
    updateUser: builder.mutation<User, UpdateUserRequest>({
      query: (userData) => ({
        url: '/me',
        method: 'PUT',
        body: userData,
      }),
      invalidatesTags: ['User'],
    }),
    getUsers: builder.query<User[], { skip?: number; limit?: number }>({
      query: ({ skip = 0, limit = 100 } = {}) => `/?skip=${skip}&limit=${limit}`,
      providesTags: ['User'],
    }),
    getUser: builder.query<User, number>({
      query: (userId) => `/${userId}`,
      providesTags: ['User'],
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useUpdateUserMutation,
  useGetUsersQuery,
  useGetUserQuery,
} = userApi;
